export const arbaicLang = {
  teacherLoginr: 'ابدأ كمدرس',
  teacherLoginSubtext: 'أدخل رقم الهاتف المحمول للمتابعة',
  mobilePlaceholder: 'رقم الهاتف المحمول',
  getOtpButton: 'احصل على OTP',
  contact: 'بالمتابعة ، فإنك توافق على شروط الخدمة وسياسة الخصوصية الخاصة بنا',
};
